import { NewDriveItemsAction, NewDriveItemsActionKeys } from './actions';
import Utils from '../../../utils';

export interface NewDriveItemsState {
	isLoaded: boolean;
	isFetching: boolean;
	items: { [k: number]: NewItemState };
}

export interface NewItemState {
	additionDate: number;
}

const initialState: NewDriveItemsState = {
	isLoaded: false,
	isFetching: false,
	items: {}
};

const initialNewItemState: NewItemState = {
	additionDate: new Date().getTime() // temporarily set at date of addition to store; waiting for backend to add a real date of addition to gallery
};

export function newDriveItems(state: NewDriveItemsState = initialState, action: NewDriveItemsAction): NewDriveItemsState {

	let newState = Utils.deepCopy(state);
	switch (action.type) {
		case NewDriveItemsActionKeys.INIT_NEW_ITEMS_STORE:
			action.storedNewItems.forEach(item => newState.items[item.id] = {
				additionDate: item.additionDate
			});
			return newState;
		case NewDriveItemsActionKeys.REQUEST_NEW_DRIVE_ITEMS:
			newState.isFetching = true;
			return newState;
		case NewDriveItemsActionKeys.RECEIVED_NEW_DRIVE_ITEMS:
			newState.isLoaded = true;
			newState.isFetching = false;
			return newState;
		case NewDriveItemsActionKeys.ADD_ITEM:
			let newItem: NewItemState = getItemFromMap(newState.items, action.id);
			newState.items[action.id] = newItem;
			return newState;
		case NewDriveItemsActionKeys.REMOVE_ITEM:
			delete newState.items[action.id];
			return newState;
		default:
			return state;
	}
}

function getItemFromMap(items: { [k: number]: NewItemState }, itemId: number): NewItemState {
	return items[itemId] ? items[itemId] : Utils.deepCopy(initialNewItemState);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/New/reducer.ts